import { v4 as uuidv4 } from 'uuid';
export var getUUID = function getUUID() {
  // Get a Temporary ID from a local storage, if it exists
  //@ts-expect-error TODO: fix this
  var tempId = localStorage.getItem('temp_id');
  if (tempId) {
    return tempId;
  }

  // If the Temporary ID exists in an old legacy 'session_id' key (delete the legacy key and move to the new one)
  var sessionId = localStorage.getItem('session_id');
  if (sessionId) {
    localStorage.setItem('temp_id', sessionId);
    localStorage.removeItem('session_id');
    return sessionId;
  }

  // Temporary ID does not exist, create one
  var uuid = uuidv4(); // UUID with timestamp
  localStorage.setItem('temp_id', uuid);
  return uuid;
};